/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ArchiveProofRequest model module.
 * @module model/ArchiveProofRequest
 * @version V1
 */
class ArchiveProofRequest {
    /**
     * Constructs a new <code>ArchiveProofRequest</code>.
     * @alias module:model/ArchiveProofRequest
     */
    constructor() { 
        
        ArchiveProofRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ArchiveProofRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ArchiveProofRequest} obj Optional instance to populate.
     * @return {module:model/ArchiveProofRequest} The populated <code>ArchiveProofRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ArchiveProofRequest();

            if (data.hasOwnProperty('proofIds')) {
                obj['proofIds'] = ApiClient.convertToType(data['proofIds'], ['Number']);
            }
            if (data.hasOwnProperty('note')) {
                obj['note'] = ApiClient.convertToType(data['note'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ArchiveProofRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ArchiveProofRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['proofIds'])) {
            throw new Error("Expected the field `proofIds` to be an array in the JSON data but got " + data['proofIds']);
        }
        // ensure the json data is a string
        if (data['note'] && !(typeof data['note'] === 'string' || data['note'] instanceof String)) {
            throw new Error("Expected the field `note` to be a primitive type in the JSON string but got " + data['note']);
        }

        return true;
    }


}



/**
 * @member {Array.<Number>} proofIds
 */
ArchiveProofRequest.prototype['proofIds'] = undefined;

/**
 * @member {String} note
 */
ArchiveProofRequest.prototype['note'] = undefined;






export default ArchiveProofRequest;

